import React from 'react'
import PropTypes from 'prop-types'
import { ConnectivityLogShape } from 'shapes'
import SensorChart from 'components/sensor-chart'
import LoadingIndicator from 'components/loading-indicator'
import NoDataMessage from 'components/no-data-message'

export default class HistoricalSensorChart extends React.PureComponent {
  static propTypes = {
    sensor: PropTypes.object.isRequired,
    historicalData: PropTypes.object.isRequired,
    connectivityData: PropTypes.arrayOf(ConnectivityLogShape),
    xStart: PropTypes.string.isRequired,
    xEnd: PropTypes.string.isRequired,
    highlighted: PropTypes.object,
    highlightX: PropTypes.func
  }

  render () {
    const {
      sensor,
      historicalData,
      connectivityData,
      xStart,
      xEnd,
      highlighted,
      highlightX
    } = this.props

    if (historicalData.error) {
      return <p className="error">{historicalData.error}</p>
    }

    if (historicalData.isFetching) {
      return <LoadingIndicator />
    }

    if (!historicalData.data || !historicalData.data.length) {
      return <NoDataMessage />
    }

    return (
      <SensorChart
        data={historicalData.data}
        connectivityData={connectivityData}
        xStart={xStart}
        xEnd={xEnd}
        sensor={sensor}
        highlighted={highlighted}
        highlightX={highlightX} />
    )
  }
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/historical-sensor-chart/index.js